<template>
  <section class="va-home-section">
    <vetalfa-home-section-header
      title="Recomendados"
      :action-text="mobile ? null : 'Ver outros'"
      @action="$emit('shuffle')"
    ></vetalfa-home-section-header>

    <!-- Mobile: estante horizontal com o próximo card aparecendo. -->
    <div v-if="mobile" class="va-shelf">
      <div class="va-shelf-track">
        <div
          v-for="(item, index) in items"
          :key="`home-recommended-${item.id}-${index}`"
          class="va-rec-card va-shelf-card"
          role="button"
          tabindex="0"
          :aria-label="`${typeLabel(item)}: ${displayName(item)}`"
          @click="$emit('select', { item, position: index })"
          @keydown.enter.prevent="$emit('select', { item, position: index })"
          @keydown.space.prevent="$emit('select', { item, position: index })"
        >
          <span class="va-rec-type">{{ typeLabel(item) }}</span>
          <span class="va-rec-name">{{ displayName(item) }}</span>
        </div>
      </div>
    </div>

    <!-- Desktop: três colunas. -->
    <div v-else class="va-home-grid va-rec-grid">
      <div
        v-for="(item, index) in desktopItems"
        :key="`home-recommended-${item.id}-${index}`"
        class="va-rec-card va-rec-card-desktop"
        role="button"
        tabindex="0"
        :aria-label="`${typeLabel(item)}: ${displayName(item)}`"
        @click="$emit('select', { item, position: index })"
        @keydown.enter.prevent="$emit('select', { item, position: index })"
        @keydown.space.prevent="$emit('select', { item, position: index })"
      >
        <span class="va-rec-type">{{ typeLabel(item) }}</span>
        <span class="va-rec-name">{{ displayName(item) }}</span>
      </div>
    </div>
  </section>
</template>

<style>
.va-rec-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.va-rec-card-desktop {
  padding: 16px;
}
</style>

<script>
import HomeSectionHeader from "@/components/home/HomeSectionHeader.vue";
import contentRoutes from "@/constants/content.routes.js";

export default {
  name: "HomeRecommended",
  components: {
    "vetalfa-home-section-header": HomeSectionHeader,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** Desktop mostra três colunas; o mobile lista todos na estante. */
    desktopItems() {
      return this.items.slice(0, 3);
    },
  },
  methods: {
    typeLabel(item) {
      return contentRoutes.getContentTypeLabel(item);
    },
    displayName(item) {
      return contentRoutes.getDisplayName(item);
    },
  },
};
</script>
